const REDIRECT_TIMEOUT_MS = 1500;

export function mobileRedirect(href) {
    setTimeout(function () {
        window.location.href = href;
    }, REDIRECT_TIMEOUT_MS);
}
